import { useSelector } from "react-redux";
import { userSelectors } from "store/slices/user";

export const useHasActiveStripe = () => {
  const [mediaOwner] = useSelector(userSelectors.mediaOwner);
  return mediaOwner?.stripe_account && mediaOwner?.stripe_actived;
};

export default useHasActiveStripe;
